module.exports = __webpack_public_path__ + "img/Save.054bafff.svg";